import { createFileRoute } from "@tanstack/react-router";
import { SubsidizeLeaseSellPage } from "@/components/guides/SubsidizeLeaseSellPage";
import { subsidizeLeaseSellSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/subsidize-lease-or-sell")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    subsidizeLeaseSellSeo(loaderData?.href ?? "/guides/subsidize-lease-or-sell"),
  component: SubsidizeLeaseSellPage,
});
